import actions from '../actionTypes';
import * as Constants from '../../utilities/constants/Constants';
import { string } from '../../localization';
import Line from '../../utilities/Icons/TextTab/orientation/line.svg';
import Circle from '../../utilities/Icons/TextTab/orientation/circle.svg';
import Concave from '../../utilities/Icons/TextTab/orientation/concave.svg';
import Convex from '../../utilities/Icons/TextTab/orientation/convex.svg';

const initialState = {
  showSideBar: false,
  activeSideBarTab: null,
  activeTemplatesTab: Constants.inspirationsTab,
  activeMaterialTab: 'material',
  folderListElements: null,
  searchBarIsVisible: false,
  materialIndex: 0,
  colorPickerSource: null,
  colorToSearch: null,
  shouldLoadMoreContents: false,
  showLoading: false,
  searchTags: {
    updatedPatternColor: null,
    updatedText: null,
    updatedPage: 0,
    previousPatternColor: null,
    previousText: null
  },
  searchMode: false,
  searchedContents: [],
  patternCount: Constants.PATTERN_COUNT,
  unsplashData: [],
  vecteezyData: [],
  dreamstimeData: [],
  adobeStockData: [],
  hpMosaicData: [],
  gettyImageData: [],
  gettyImageBackgroundData: [],
  gettyImagePhotosData: [],
  gettyImageObjectsData: [],
  iStockBackgroundData: [],
  iStockPhotosData: [],
  iStockObjectsData: [],
  instagramRetryCount: 0,
  instagramData: [],
  instagramElementsNextURL: null,
  instagramLoginFlag: false,
  addText: {
    id: null,
    customText: null,
    buttonState: false,
    fontPath: [
      {
        name: 'line',
        active: true,
        iconPath: Line,
        selectedIconPath: Line
      },
      {
        name: 'arc_concave',
        active: false,
        iconPath: Concave,
        selectedIconPath: Concave
      },
      {
        name: 'arc_convex',
        active: false,
        iconPath: Convex,
        selectedIconPath: Convex
      },
      {
        name: 'arc_circle',
        active: false,
        iconPath: Circle,
        selectedIconPath: Circle
      }
    ],
    fontId: null,
    selectedFontPath: 'line',
    textColor: '#000000',
    shadowColor: 'none',
    shadowText: string.NO_SHADOW_KEY,
    // textAlign: { value: 'middle', label: string.TEXT_ANCHOR_MIDDLE },
    textAlign: 'middle',
    loaderState: 'd-none'
  },
  upload: {
    file: null
  },
  uploadErrorFlag: null,
  inspirationCategory: [],
  inspirationDetails: {
    previewImage: null,
    dataJSON: null
  },
  inspirations: {
    portraitInspirations: [],
    landscapeInspirations: [],
    offset: 0,
    category: Constants.allInspirationCategory
  },
  documentColors: [],
  uploadInfo: {
    uploadArray: [],
    userPhotoUploadType: {}
  },
  uploadDialogue: false,
  isUploadLogo: false,
  isLoadingIcon: false,
  activeTheme: null,
  dropboxUploadDialog: false,
  dropboxfile: [],
  dropboxFileIndex: 0,
  minimumViewingDistance: null,
  recolor: null,
  recolorArray: [],
  triggerRedraw: false,
  isMaximumLimit: false,
  pattrenDesignCost: {
    price: null,
    currency: null,
    currencySymbol: null
  },
  fileSize: null,
  uploadStatus: null,
  handleBottomBreadcrumbClick: '',
  loaderCoordinates: { left: null, top: null },
  dropBoxErrorFlag: false,
  dropBoxErrorDict: {
    header: '',
    contents: []
  },
  tabTime: 0,
  tabName: null,
  solidBackgroundColor: null
};

export default function sideBarReducer(state = initialState, action) {
  switch (action.type) {
    case actions.SET_SIDEBAR_VISIBILITY:
      return { ...state, showSideBar: action.payload.value };
    case actions.CHANGE_SIDEBAR_TAB:
      return { ...state, activeSideBarTab: action.payload.activeSideBarTab };
    case actions.SET_FOLDER_LIST_ELEMENTS:
      return {
        ...state,
        folderListElements: action.payload.folderListElements
      };
    case actions.SET_TEXT_ID:
      return {
        ...state,
        addText: {
          ...state.addText,
          id: action.payload.id
        }
      };

    case actions.SET_CUSTOM_TEXT:
      return {
        ...state,
        addText: {
          ...state.addText,
          customText: action.payload.customText,
          buttonState: action.payload.buttonState
        }
      };
    case actions.SET_FONT_FAMILY:
      return {
        ...state,
        addText: {
          ...state.addText,
          fontId: action.payload.value
          // buttonState: action.payload.buttonState
        }
      };
    case actions.SET_FONT_PATH:
      return {
        ...state,
        addText: {
          ...state.addText,
          fontPath: action.payload.fontPath,
          selectedFontPath: action.payload.selectedFontPath
          // buttonState: action.payload.buttonState
        }
      };
    case actions.SET_TEXT_COLOR:
      return {
        ...state,
        addText: {
          ...state.addText,
          textColor: action.payload.value
          // buttonState: action.payload.buttonState
        }
      };
    case actions.SET_SHADOW_COLOR:
      return {
        ...state,
        addText: {
          ...state.addText,
          shadowColor: action.payload.value,
          shadowText: action.payload.text
          // buttonState: action.payload.buttonState
        }
      };
    case actions.SET_TEXT_ALIGNMENT:
      return {
        ...state,
        addText: {
          ...state.addText,
          textAlign: action.payload.value
          // buttonState: action.payload.buttonState
        }
      };
    case actions.SET_TEXT_ATTRIBUTES:
      return {
        ...state,
        addText: {
          ...state.addText,
          textAlign: action.payload.textAlign,
          shadowColor: action.payload.shadowColor,
          shadowText: action.payload.shadowText,
          textColor: action.payload.textColor,
          fontPath: action.payload.fontPath,
          selectedFontPath: action.payload.selectedFontPath,
          fontId: action.payload.fontId,
          customText: action.payload.customText,
          buttonState: action.payload.buttonState,
          id: action.payload.id
        }
      };

    case actions.SET_LOADER_STATE:
      return {
        ...state,
        addText: {
          ...state.addText,
          loaderState: action.payload.loaderState,
          buttonState: action.payload.buttonState
        }
      };
    case actions.SET_UPLOAD_FILE:
      return {
        ...state,
        upload: {
          ...state.upload,
          file: action.payload.file
        }
      };
    case actions.SET_UPLOAD_FILE_STATUS:
      return {
        ...state,
        uploadDialogue: action.payload.uploadDialogue
      };
    case actions.SET_OR_HIDE_SEARCH_BAR:
      return {
        ...state,
        searchBarIsVisible: !state.searchBarIsVisible
      };
    case actions.SET_COLOR_TO_SEARCH:
      return {
        ...state,

        colorToSearch: action.payload.value
      };
    case actions.ELEMEMT_LIST_UNMOUNT:
      return {
        ...state,
        searchBarIsVisible: false
      };
    case actions.SET_SHOULD_LOAD_MORE_CONTENTS:
      return {
        ...state,
        shouldLoadMoreContents: action.payload.shouldLoadMoreContents
      };
    case actions.SHOW_LOADING_DIALOG:
      return {
        ...state,
        showLoading: action.payload.showLoading
      };

    case actions.SET_SEARCH_TAGS:
      return {
        ...state,
        searchTags: {
          ...state.searchTags,
          updatedPatternColor: action.payload.updatedPatternColor,
          updatedText: action.payload.updatedText,
          updatedPage: action.payload.updatedPage
        }
      };
    case actions.SET_OLD_SEARCH_TAGS:
      return {
        ...state,
        searchTags: {
          ...state.searchTags,
          previousPatternColor: action.payload.previousPatternColor,
          previousText: action.payload.previousText
        }
      };
    case actions.SET_SEARCH_CONTENTS:
      return {
        ...state,
        searchMode: action.payload.searchMode,
        searchedContents: action.payload.searchedContents
      };
    case actions.FETCH_UNSPLASH_CONTENTS:
      return {
        ...state,
        unsplashData: action.payload.unsplashData
      };
    case actions.FETCH_ADOBE_STOCK_CONTENTS:
      return {
        ...state,
        adobeStockData: action.payload.adobeStockData
      };
    case actions.FETCH_HP_MOSAIC_DATA:
      return {
        ...state,
        hpMosaicData: action.payload.hpMosaicData
      };
    case actions.FETCH_VECTEEZY_CONTENTS:
      return {
        ...state,
        vecteezyData: action.payload.vecteezyData
      };
    case actions.FETCH_GETTY_IMAGE_CONTENTS:
      return {
        ...state,
        gettyImageData: action.payload.gettyImageData
      };
    case actions.FETCH_GETTY_IMAGE_BACKGROUND_CONTENTS:
      return {
        ...state,
        gettyImageBackgroundData: action.payload.gettyImageBackgroundData
      };
    case actions.FETCH_GETTY_IMAGE_PHOTOS_CONTENTS:
      return {
        ...state,
        gettyImagePhotosData: action.payload.gettyImagePhotosData
      };
    case actions.FETCH_GETTY_IMAGE_OBJECTS_CONTENTS:
      return {
        ...state,
        gettyImageObjectsData: action.payload.gettyImageObjectsData
      };
    case actions.FETCH_I_STOCK_BACKGROUND_CONTENTS:
      return {
        ...state,
        iStockBackgroundData: action.payload.iStockBackgroundData
      };
    case actions.FETCH_I_STOCK_PHOTOS_CONTENTS:
      return {
        ...state,
        iStockPhotosData: action.payload.iStockPhotosData
      };
    case actions.FETCH_I_STOCK_OBJECTS_CONTENTS:
      return {
        ...state,
        iStockObjectsData: action.payload.iStockObjectsData
      };
    case actions.SET_COLOR_PICKER_SOURCE:
      return {
        ...state,
        colorPickerSource: action.payload.value
      };
    case actions.SET_DOCUMENT_COLORS:
      return {
        ...state,
        documentColors: action.payload.documentColors
      };
    case actions.CHANGE_TEMPLATES_TAB:
      return {
        ...state,
        activeTemplatesTab: action.payload.activeTemplatesTab
      };
    case actions.CHANGE_MATERIAL_TAB:
      return {
        ...state,
        activeMaterialTab: action.payload.activeMaterialTab
      };
    case actions.SET_INSPIRATION_CATEGORY:
      return {
        ...state,
        inspirationCategory: action.payload.inspirationCategory
      };
    case actions.SET_INSPIRATIONS:
      return {
        ...state,
        inspirations: {
          ...state.inspirations,
          portraitInspirations: action.payload.portraitInspirations,
          landscapeInspirations: action.payload.landscapeInspirations
        }
      };
    case actions.SET_INSPIRATION_OFFSET:
      return {
        ...state,
        inspirations: {
          ...state.inspirations,
          offset: action.payload.offset
        }
      };
    case actions.SET_INSPIRATION_FILTER:
      return {
        ...state,
        inspirations: {
          ...state.inspirations,
          category: action.payload.category
        }
      };
    case actions.SET_UPLOAD_CONTENTS:
      return {
        ...state,
        uploadInfo: {
          ...state.uploadInfo,
          uploadArray: action.payload.uploadArray
        }
      };
    case actions.SET_UPLOAD_USER_PHOTO_TYPE:
      return {
        ...state,
        uploadInfo: {
          ...state.uploadInfo,
          userPhotoUploadType: action.payload.userPhotoUploadType
        }
      };
    case actions.SET_THEME:
      return {
        ...state,
        activeTheme: action.payload.theme
      };
    case actions.MATERIAL_INDEX:
      return {
        ...state,
        materialIndex: action.payload.value
      };
    case actions.SET_DROPBOX_UPLOAD_DIALOG:
      return {
        ...state,
        dropboxUploadDialog: action.payload.dropboxUploadDialog
      };
    case actions.SET_DROPBOX_FILES:
      return {
        ...state,
        dropboxfile: action.payload.dropboxfile
      };
    case actions.SET_IS_UPLOAD_LOGO:
      return {
        ...state,
        isUploadLogo: action.payload.isUploadLogo
      };
    case actions.SHOW_LOADING_ICON:
      return {
        ...state,
        isLoadingIcon: action.payload
      };
    case actions.TRIGGER_COMPONENT_REDRAW:
      return {
        ...state,
        triggerRedraw: !state.triggerRedraw
      };
    case actions.IS_MAXIMUM_LIMIT:
      return {
        ...state,
        isMaximumLimit: action.payload.isMaximumLimit
      };
    case actions.PATTERN_DESIGN_COST:
      return {
        ...state,
        pattrenDesignCost: {
          ...state.pattrenDesignCost,
          price: action.payload.cost,
          currency: action.payload.currency,
          currencySymbol: action.payload.currencySymbol
        }
      };
    case actions.FETCH_DREAMSTIME_CONTENTS:
      return {
        ...state,
        dreamstimeData: action.payload.dreamstimeData
      };
    case actions.SET_DROPBOX_FILE_INDEX:
      return {
        ...state,
        dropboxFileIndex: action.payload.dropboxFileIndex
      };
    case actions.SET_UPLOAD_FILE_PERCENTAGE:
      return {
        ...state,
        uploadStatus: action.payload.uploadStatus
      };
    case actions.SET_FILE_SIZE:
      return {
        ...state,
        fileSize: action.payload.fileSize
      };
    case actions.SET_INSTAGRAM_CONTENTS:
      return {
        ...state,
        instagramData: action.payload.instagramData
      };
    case actions.SET_INSTAGRAM_NEXT_URL:
      return {
        ...state,
        instagramElementsNextURL: action.payload.instagramElementsNextURL
      };
    case actions.HANDLE_BOTTOM_BREADCRUMB_CLICK:
      return {
        ...state,
        handleBottomBreadcrumbClick: action.payload.value
      };
    case actions.SET_UPLOAD_ERROR_FLAG:
      return {
        ...state,
        uploadErrorFlag: action.payload.uploadErrorFlag
      };
    case actions.SET_INSTAGRAM_LOGIN_FLAG:
      return {
        ...state,
        instagramLoginFlag: action.payload.instagramLoginFlag
      };
    case actions.SET_LOADER_COORDINATES:
      return {
        ...state,
        loaderCoordinates: action.payload.loaderCoordinates
      };
    case actions.DROPBOX_ERROR_FLAG:
      return {
        ...state,
        dropBoxErrorFlag: action.payload.dropBoxErrorFlag
      };
    case actions.DROPBOX_ERROR_PARAMS:
      return {
        ...state,
        dropBoxErrorDict: action.payload.dropBoxErrorDict
      };
    case actions.TAB_USAGE_DURATION:
      return {
        ...state,
        tabTime: action.payload.tabTime,
        tabName: action.payload.tabName
      };
    case actions.SET_SOLID_BACKGROUND_COLOR:
      return {
        ...state,
        solidBackgroundColor: action.payload.solidBackgroundColor
      };
    case actions.SET_INSTAGRAM_RETRY_COUNT:
      return {
        ...state,
        instagramRetryCount: action.payload.instagramRetryCount
      };

    default:
      return state;
  }
}
